import axios from 'axios';
import moment from 'moment';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import './style.css';

const saveData = (function () {
  var a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  return function (data, fileName) {
    const blob = new Blob([data], { type: 'octet/stream' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();

class AppointmentCSV extends Component {
  downloadCSV = async (month, year) => {
    await axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/admin/appointments-csv?month=${month}&year=${year}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(response => {
        saveData(response.data, 'test.csv');
      })
      .catch(() => {
        alert('Problem getting the report!');
      });
  }

  past24Months = () => {
    const res = [];
    for (let i = 0; i < 24; i += 1) {
      const d = moment().subtract(i, 'months');
      const month = d.month() + 1; // moment months are 0 indexed
      const year = d.year();
      res.push([month, year]);
    }
    return res;
  }

  renderDownloadLinks() {
    return (
      <ul>
        {this.past24Months().map(d => {
          return (
            <li key={`${d[0]}-${d[1]}`}>
              <a
                href="#"
                onClick={() => {
                  this.downloadCSV(d[0], d[1]);
                }}
              >
                Appointments for {d[0]}/{d[1]}
              </a>
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    return (
      <div className="ManageAppointments">
        <div className="col-auto">
          <div className="row">
            <div className="card">{this.renderDownloadLinks()}</div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export default connect(
  mapStateToProps,
  {}
)(AppointmentCSV);



// WEBPACK FOOTER //
// ./src/pages/admin/routes/AppointmentCSV/index.js